export default "__VITE_ASSET__Ci1$JT1f__"